import React from 'react'
import { createPortal } from 'react-dom'
import { formatCurrency } from '../../utils/cart.js'

const PosPrintableReceipt = ({ sale, businessName }) => {
  const soldAt = new Date(sale.createdAt || Date.now())

  return createPortal(
    <article className='pos-print-receipt'>
      <header className='pos-print-receipt-header'>
        <strong>{businessName || 'Sales receipt'}</strong>
        <span>Receipt</span>
      </header>
      <p className='pos-print-receipt-meta'>
        Transaction: {sale.barcode}
        <br />
        {soldAt.toLocaleString()}
        {sale.cashier?.name && (
          <>
            <br />
            Cashier: {sale.cashier.name}
          </>
        )}
      </p>
      <div className='pos-print-receipt-items'>
        {sale.items.map((item, index) => (
          <div
            className='pos-print-receipt-item'
            key={`${item.inventory || item.upc || item.item}-${index}`}
          >
            <strong>{item.subname || item.item || item.upc}</strong>
            <div className='pos-print-receipt-line'>
              <span>
                {item.quantity} × {formatCurrency(item.price)}
              </span>
              <strong>{formatCurrency(item.lineSubtotal)}</strong>
            </div>
            {item.itemdiscount > 0 && (
              <small>Discount: {item.itemdiscount}%</small>
            )}
          </div>
        ))}
      </div>
      <dl className='pos-print-receipt-totals'>
        <div>
          <dt>Subtotal</dt>
          <dd>{formatCurrency(sale.subtotal)}</dd>
        </div>
        {sale.discount > 0 && (
          <div>
            <dt>Discount</dt>
            <dd>-{formatCurrency(sale.discount)}</dd>
          </div>
        )}
        {sale.shipping > 0 && (
          <div>
            <dt>Shipping</dt>
            <dd>{formatCurrency(sale.shipping)}</dd>
          </div>
        )}
        <div>
          <dt>Tax</dt>
          <dd>{formatCurrency(sale.taxes)}</dd>
        </div>
        <div className='pos-print-receipt-total'>
          <dt>Total</dt>
          <dd>{formatCurrency(sale.total)}</dd>
        </div>
      </dl>
      <footer>Thank you for your purchase</footer>
    </article>,
    document.body
  )
}

export default PosPrintableReceipt
